// import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG } from "./actionTypes"

import {
  GET_PROFILE_START,
  GET_PROFILE_ERROR,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_RESET,
  CREATE_PROFILE_START,
  CREATE_PROFILE_SUCCESS,
  CREATE_PROFILE_ERROR,
  CREATE_PROFILE_RESET,
} from "./actionTypes"

// CREATE_PROFILE

export const createProfileStart = payload => {
  console.log(payload)
  return {
    type: CREATE_PROFILE_START,
    payload: payload,
  }
}

export const createProfileSuccess = payload => {
  console.log(payload)
  return {
    type: CREATE_PROFILE_SUCCESS,
    payload: payload,
  }
}

export const createProfileError = error => {
  return {
    type: CREATE_PROFILE_ERROR,
    payload: error,
  }
}

export const createProfileReset = () => {
  return {
    type: CREATE_PROFILE_RESET,
  }
}

// GET PROFILE

export const GetProfileStart = () => {
  return {
    type: GET_PROFILE_START,
  }
}

export const GetProfileSuccess = payload => {
  return {
    type: GET_PROFILE_SUCCESS,
    payload: payload,
  }
}

export const GetProfileError = error => {
  return {
    type: GET_PROFILE_ERROR,
    payload: error,
  }
}

export const GetProfileReset = () => {
  return {
    type: GET_PROFILE_RESET,
  }
}

// export const editProfile = user => {
//   return {
//     type: EDIT_PROFILE,
//     payload: { user },
//   }
// }

// export const profileSuccess = msg => {
//   return {
//     type: PROFILE_SUCCESS,
//     payload: msg,
//   }
// }

// export const profileError = error => {
//   return {
//     type: PROFILE_ERROR,
//     payload: error,
//   }
// }

// export const resetProfileFlag = error => {
//   return {
//     type: RESET_PROFILE_FLAG,
//   }
// }
